/* eslint-disable */
import React, { Component } from "react";
import NavLogo from "../assets/LogoFull.svg";
import NewHere from "./nav/NewHere.js";
import AdditionalPages from "./nav/AdditionalPages.js";

import $ from "jquery";
import LegacyWebsite from "./LegacyWebsite.js";

class OtherPageNavigation extends Component {
	//Stop the dropdown nav from reloading the page on collapsed nav and imporved dropdown functionality
	//Edited from scripts.js
	componentDidMount() {
		$("#topMain li.dropdown > a, #topMain li.dropdown-submenu > a").bind("click", function (e) {
			var addActiveClass = false;
			if ($(this).attr("href") == "#") {
				e.preventDefault();
			}

			e.stopPropagation();

			if ($(window).width() > 990) {
				return;
			}

			addActiveClass = $(this).parent().hasClass("resp-active");
			$("#topMain").find(".resp-active").removeClass("resp-active");
			$("#topMain").find(".active").removeClass("active");

			if (!addActiveClass) {
				$(this).parents("li").addClass("resp-active");
			}
		});
	}

	render() {
		return (
			<section>
				{/* TOP NAV */}
				<header id="topNav">
					<LegacyWebsite/>
					<div className="container">
						{/*Mobile Menu Button */}
						<button className="btn btn-mobile" data-toggle="collapse" data-target=".nav-main-collapse">
							<i className="fa fa-bars"></i>
						</button>

						<a className="logo" href="/">
							<img src={NavLogo} height="60" alt="KCRC Logo" />
						</a>

						<div className="navbar-collapse nav-main-collapse collapse pull-right">
							<nav className="nav-main mega-menu">
								<ul className="nav nav-pills nav-main" id="topMain">
									{<NewHere />}
									{<AdditionalPages />}
									<li>
										<a href="/">Back to Home Page</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</header>
			</section>
		);
	}
}

export default OtherPageNavigation;
